module.exports = __webpack_public_path__ + "staticVue/img/cts-logo.ded81339.png";